import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
import { MultiMatrix } from '@shared/models/question-types/multi-matrix';
import { QuestionBaseComponent } from '../question-base/question-base.component';
import { MultiMatrixTableComponent } from './multi-matrix-table/multi-matrix-table.component';

@Component({
  selector: 'app-multi-matrix',
  standalone: true,
  imports: [
    CommonModule,
    MultiMatrixTableComponent,
    TranslateModule,
    QuestionBaseComponent,
  ],
  templateUrl: './multi-matrix.component.html',
  styleUrl: './multi-matrix.component.scss',
})
export class MultiMatrixComponent {
  @Input() multiMatrixQuestion!: MultiMatrix;
  @Input() form?: FormGroup;
  @Input() isFirstQuestion = false;

  get hasColumnsAndRows(): boolean {
    return (
      Array.isArray(this.multiMatrixQuestion?.columns) &&
      this.multiMatrixQuestion.columns.length > 0 &&
      Array.isArray(this.multiMatrixQuestion.columns[0].rows) &&
      this.multiMatrixQuestion.columns[0].rows.length > 0
    );
  }

  get mandatoryValue(): boolean {
    return this.hasColumnsAndRows
      ? !!this.multiMatrixQuestion.columns[0].rows[0]?.mandatory
      : false;
  }
}
